<template>
  <div class="sign">
    <div class="sign-search">
      <div class="btn-box">
        <van-field
          size="small"
          v-model="key"
          placeholder="采购单/提货单/进仓单/参考号"
          :formatter="relationNumberFmt"
          @keyup.13="getList()"
        />
      </div>

      <div class="toSearch-box">
        <button class="sign-toSearch" @click="getList()">查询</button>
      </div>
    </div>

    <div class="sign-item">
      <template v-if="startSearch">
        <van-loading size="24px" vertical>加载中...</van-loading>
      </template>
      <template v-else>
        <template v-if="list.length">
          <ul>
            <li v-for="(item, index) in list" :key="index">
              <div class="sign-list">
                <strong>单号信息</strong>
              </div>
              <div class="sign-list">
                <p>单号：{{ item.trackNumber }}</p>
                <p>箱数：{{ item.boxCount }}</p>
              </div>
              <div class="sign-list">
                <p>总重量：{{ item.totalWeight }}</p>
                <p>总体积：{{ item.totalVolume }}</p>
              </div>
              <span v-if="item.bussbusinessType !== 2">
                <div class="sign-list">
                  <strong>产品信息</strong>
                </div>
                <div class="sign-list">
                  <p>SKU：{{ item.sku }}</p>
                </div>
                <div class="sign-list">
                  <p>数量：{{ item.totalQty }}</p>
                </div>
              </span>
              <div class="sign-list">
                <strong>司机信息</strong>
              </div>
              <div class="sign-list">
                <p>
                  {{ item.driverCarNumber }} {{ item.driverName }}
                  {{ item.driverPhone }}
                </p>
              </div>
              <div class="photo">
                <div class="sign-photo-cpntent">
                  <div class="sign-photo-box">
                    <ul>
                      <div>
                        <p>到场办单 {{ item.deliveryInStoreDate }}</p>
                        <div class="sign-photo-item" v-if="imgObj.fbaImageUrl">
                          <span
                            class="delete-icon"
                            @click="deleteImg('fbaImageUrl')"
                            >x</span
                          >
                          <!-- <van-icon name="photo" size="6em" color="#169bd5"/> -->
                          <img
                            :src="imgObj.fbaImageUrl"
                            class="sign-photo-item-img"
                            alt=""
                            @click="previewImage(imgObj.fbaImageUrl)"
                          />
                        </div>

                        <div class="sign-photo-btn" v-else>
                          <div class="photo">
                            <input
                              class="img hidden image0"
                              @change="changeImg(0)"
                              type="file"
                              name="cover"
                              ref="inputer"
                              accept="image/*"
                            />
                            <p @click="chooseImage(0)">
                              <i class="el-icon-camera"></i>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div>
                        <p>卸货核收 {{ item.deliveryCheckDate }}</p>
                        <div
                          class="sign-photo-item"
                          v-if="imgObj.cartonLabelImageUrl"
                        >
                          <span
                            class="delete-icon"
                            @click="deleteImg('cartonLabelImageUrl')"
                            >x</span
                          >
                          <!-- <van-icon name="photo" size="6em" color="#169bd5"/> -->
                          <img
                            :src="imgObj.cartonLabelImageUrl"
                            class="sign-photo-item-img"
                            alt=""
                            @click="previewImage(imgObj.cartonLabelImageUrl)"
                          />
                        </div>

                        <div class="sign-photo-btn" v-else>
                          <div class="photo">
                            <input 
                              class="img hidden image1"
                              @change="changeImg(1)"
                              type="file"
                              name="cover"
                              ref="inputer1"
                              accept="image/*"
                            />
                            <p @click="chooseImage(1)">
                              <i class="el-icon-camera"></i>
                            </p>
                          </div>
                        </div>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </template>
        <template v-else>
          <van-empty image="search" description="暂无数据" />
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Empty,
  List,
  PullRefresh,
  cell,
  Toast,
  Loading,
  Button,
} from "vant";
import { getAppointmentCheck } from "@/api/mobile_Reserve/mobileReserve_api";
import { getUrlParams } from "util/util";
import { axios, BaseOpenApiUrl } from "@/api/axios_config";
export default {
  data() {
    return {
      list: [],
      inCarImg: [],
      xieImg: [],
      imgType:0,
      imgObj: { fbaImageUrl: "", cartonLabelImageUrl: "" },
      saveInCarImgUrlArr: [],
      saveXieImgUrlArr: [],
      imgFiles:[],
      loading: false,
      startSearch: false,
      saveImgUrlArr: [],
      key: "",
    };
  },
  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Empty.name]: Empty,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [cell.name]: cell,
    [Toast.name]: Toast,
    [Loading.name]: Loading,
    [Field.name]: Field,
    [Button.name]: Button,
  },
  computed: {},
  created() {
    this.init();
  },
  methods: {
    deleteImg(type) {
      this.$set(this.imgObj, type, "");

      this.saveImgUrlArr.forEach((item, i) => {
        if (type == "fbaImageUrl" && item.labelingType === 1) {
          // FBA
          this.saveImgUrlArr.splice(i, 1);
        }

        if (type == "cartonLabelImageUrl" && item.labelingType === 2) {
          this.saveImgUrlArr.splice(i, 1);
        }
      });
    },
    // 预览图片
    previewImage(url) {
      ImagePreview({
        images: [url],
        closeable: true,
      });
    },
    submitImg(bussType) {
      const that = this;

      let formDatas = new FormData();

      this.imgFiles.forEach((i, index) => {
        formDatas.append("files", i);
      });
      console.info(this.list[0].tfDeliveryOrderID);
      formDatas.append("tfDeliveryOrderID", this.list[0].tfDeliveryOrderID);
      formDatas.append("bussType", bussType);
      Toast.loading({
        message: "上传中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      axios({
        url: `${BaseOpenApiUrl}/MakeAppointmen/InsertCheckFtpImage`,
        method: "post",
        data: formDatas,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((res) => {
        Toast.clear();
        if (res.data.status === 200 && res.data.success) {
          Toast.fail("操作成功");
          this.imgFiles = [];
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
     changeImg(bussType) {
      console.info(bussType);
      const img = document.getElementsByClassName("image"+bussType)[0];

      if (!img.files.length) return;

      this.handleFiles(img.files);

      let imgList = [...img.files];

      this.imgFiles.push(...imgList);

      this.submitImg(bussType);
    },
     chooseImage(type) {
      this.imgType = type;
      console.info("image"+type);
      document.getElementsByClassName("image"+type)[0].click();
    },
    handleFiles(files) {
      const that = this;

      var file = files;

      const { type, name } = file[0];

      var imageType = /^image\//;
      if (!imageType.test(type)) {
        return;
      }

      var reader = new FileReader();
      reader.onload = function (e) {
        that.$set(
          that.imgObj,
          that.imgType === 0 ? "fbaImageUrl" : "cartonLabelImageUrl",
          e.target.result
        );
      };
      reader.readAsDataURL(file[0]);
    },
    init() {
      let params = getUrlParams(window.location.href);
      if (params && params.key) {
        this.key = params.key;
        this.getList();
      }
    },
    getList() {
      if (!this.key) return Toast("请输入搜索内容");

      this.list = [];

      this.startSearch = true;

      getAppointmentCheck({ key: this.key }).then((res) => {
        this.startSearch = false;
        this.loading = false;
        if (res.status === 200 && res.success) {
          const { response } = res;

          if (!response.length) return Toast("暂无匹配数据");

          this.list = response;
          const imgUrlList=this.list[0].imgUrlList;
          if (imgUrlList && imgUrlList.length) {
            imgUrlList.forEach((item, i) => {
              if (item.labelingType === 48) {
                this.$set(
                  this.imgObj,
                  "fbaImageUrl",
                  `data:image/jpg;base64,${item.urlPath}`
                );
              }
              if (item.labelingType === 49) {
                this.$set(
                  this.imgObj,
                  "cartonLabelImageUrl",
                  `data:image/jpg;base64,${item.urlPath}`
                );
              }
            });
          }
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    relationNumberFmt(v) {
      return v.trim();
    },
  },
  watch: {
    $route: async function (newValue, from) {
      this.$nextTick(() => {
        if (newValue.path === "/mobile/reserveItems") {
          this.list = [];
          this.key = "";
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .van-cell {
  border: 1px solid #adadad;
  margin-bottom: 7px;
  padding: 5px 10px;
}
.sign {
  // background-color: #fbf9fe;
}
.sign-search {
  box-sizing: border-box;
  width: 100%;
  padding: 10px 10px 3px 10px;
  display: flex;
}
.sign-search .btn-box {
  flex: 0.6;
}
.sign-search .toSearch-box {
  flex: 0.4;
  margin-left: 3%;
  min-height: 25px;
}
.sign-toSearch {
  width: 100%;
  height: 84%;
  min-height: 25px;
  background: linear-gradient(to right, #1d62f0 0%, #19d4fd 100%);
  border-radius: 5px;
  border: 0;
  color: #fff;
  font-size: 18px;
}
.hidden {
  display: none;
}
.sign-photo-box {
  box-sizing: border-box;

  ul {
    display:flex;
    flex-direction: column;
    
    .sign-photo-item {
      width: auto;
      height: 200px;
      border: 5px solid #ccc;
      box-sizing: border-box;
      position: relative;
      float: left;

      &:nth-child(3n) {
        margin-right: 0;
      }

      .delete-icon {
        position: absolute;
        background: red;
        color: #fff;
        width: 16px;
        height: 16px;
        top: 0px;
        right: 0px;
        line-height: 16px;
        font-size: 12px;
        border-radius: 16px;
        text-align: center;
      }

      .sign-photo-item-img {
        width: auto;
        height: 100%
      }
    }

    .sign-photo-btn {
      display: inline-block;
      vertical-align: top;
      width: 30.333%;

      .photo {
        height: 200px;
        width: 300px;
        position: relative;
        background-color: #faf9fc;
        position: relative;
        box-shadow: 0px 0px 7px -1px #cccccc;

        p {
          border: 1px dashed #ccc;
          padding: 10px;
          width: 50px;
          height: 50px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          margin: 0;

          i {
            font-size: 40px;
            color: #ccc;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}
.toSearch-box {
  vertical-align: top;
}
.sign-item {
  border-top: 1px solid #ccc;
}
.sign-item li {
  //border-bottom: 1px solid #ccc;
  // background-color: #fbf9fe;
  padding: 3px 10px;
  font-size: 14px;
}
.sign-list {
  display: flex;
  margin: 5px 0;
  p {
    flex: 1;
    word-break: break-all;
    margin: 0;
  }
}
</style>